import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { datadogRum } from '@datadog/browser-rum';

datadogRum.init({
  applicationId: '41f3f15b-8ab6-4599-b1b6-e4a7791de92e',
  clientToken: 'pub8c62a2b953cfb07e49d2568c172ee6fb',
  site: 'datadoghq.com',
  service: 'tyler-public-search',
  env: environment.name,
  version: '1.0.0',
  sessionSampleRate: 100,
  sessionReplaySampleRate: 20,
  trackUserInteractions: true,
  trackResources: true,
  trackLongTasks: true,
  defaultPrivacyLevel: 'mask-user-input'
});

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));

datadogRum.startSessionReplayRecording();